import { SVGProps, memo } from 'react';

const CheckboxOnboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='42'
    height='42'
    viewBox='0 0 42 42'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path='url(#clip0_270_2786)'>
      <path
        d='M23 12C26.866 12 30 15.134 30 19V22.9727C29.9999 26.8385 26.8659 29.9727 23 29.9727H18.877C15.011 29.9727 11.8771 26.8385 11.877 22.9727V19C11.877 15.134 15.011 12 18.877 12H23ZM19 23.1699L15.4102 19.5898L14 21L19 26L28 17L26.5898 15.5801L19 23.1699Z'
        fill='black'
        fill-opacity='0.56'
      />
    </g>
    <defs>
      <clipPath id='clip0_270_2786'>
        <rect width='42' height='42' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default memo(CheckboxOnboard);
